var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout-default-dialog-appbar',{attrs:{"back-to":_vm.rotalote,"withDialog":""}},[_vm._v(" "+_vm._s(_vm.nomelote)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }